module.exports = __webpack_public_path__ + "img/circle-two2.b7d73bf3.svg";